var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/*
* Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
*/
/*******************************************************************
 * @author Soongjin Park
 * @contact sjpark@detech.co.kr
 * @date 2022-09-01
 * @brief EHP 사업장 관리 개발
 *
 ********************************************************************/
import React, { useEffect, useRef, useState } from "react";
import { useAsync } from "react-async";
import { useNavigate } from 'react-router-dom';
// recoil
import { useRecoilValue, useRecoilState, } from "recoil";
import { userInfoLoginState } from "../../../recoil/userState";
import { loadingBoxState } from "../../../recoil/menuState";
// utils
import clog from "../../../utils/logUtils";
import * as CONST from "../../../utils/Const";
import * as HTTPUTIL from "../../../utils/api/HttpUtil";
import * as CUTIL from "../../../utils/commUtils";
/**
 * @brief EHP 사업장 관리 컴포넌트, 반응형 동작
 * @param -
 * @returns react components
 */
//component
function CompanyUpdate(props) {
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [isLoadingBox, setRecoilIsLoadingBox] = useRecoilState(loadingBoxState);
    //props
    const isMobile = props.isMobile;
    const workMode = props.workMode;
    const selTree = props.selTree;
    const setParentIsMobile = props.setIsMobile;
    const setParentSelTree = props.setSelTree;
    const setParentAdminType = props.setAdminType;
    const setParentWorkMode = props.setWorkMode;
    const setParentPopWin = props.setPopWin;
    //
    //화면 이동
    const navigate = useNavigate();
    //mobile check
    const mobileRef = useRef(null); // Mobile Check용
    useEffect(() => {
        function handleResize() {
            if (CUTIL.isnull(mobileRef))
                return;
            const mobileTag = mobileRef.current;
            if ((mobileTag.clientHeight <= 0) && (mobileTag.clientWidth <= 0)) {
                setParentIsMobile(true);
            }
            else {
                setParentIsMobile(false);
            }
        }
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    useEffect(() => {
        if (CUTIL.isnull(mobileRef))
            return;
        const mobileTag = mobileRef.current;
        if (!CUTIL.isnull(mobileTag)) {
            if ((mobileTag.clientHeight <= 0) && (mobileTag.clientWidth <= 0)) {
                setParentIsMobile(true);
            }
            else {
                setParentIsMobile(false);
            }
        }
    }, []);
    ////////////////////////////////////////////////////////////////////////////
    const [companyInfo, setCompanyInfo] = useState({
        "companyId": "",
        "companyName": "",
        "url": "",
        "businessNo": "",
        "administrator": "",
        "classification": "",
        "accountManager": "",
        "accMngrTelephone": "",
        "interfaceInfo": "",
        "memo": ""
        /*
        "companyId" :"",
        "companyName":"디이소프트",
        "url":"http://www.desoft.co.kr",
        "businessNo":"12345678900",
        "administrator":"오형진",
        "classification":"소프트웨어개발및공급",
        "accountManager":"박지훈",
        "accMngrTelephone":"0101112111",
        "interfaceInfo":"S/W 개발",
        "memo":"S/W 개발 전문"
        */
    });
    function callbackSetCompanyInfoMemo(val) {
        setCompanyInfo(Object.assign(Object.assign({}, companyInfo), { memo: val }));
    }
    const [errorList, setErrorList] = useState([]);
    const { data: retData, error, isLoading, reload, run, } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/api/v2/product/company/admindetail?companyId=${selTree.company.companyId}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: selTree.company.companyId
    });
    useEffect(() => {
        setRecoilIsLoadingBox(true);
        const ERR_URL = HTTPUTIL.resultCheck(isLoading, retData);
        if (ERR_URL.length > 0)
            navigate(ERR_URL);
        if (retData) {
            clog("IN COMPANY VIEW : RES : " + JSON.stringify(retData));
            if (retData.codeNum == CONST.API_200) {
                setCompanyInfo(retData.body);
            }
        }
        setRecoilIsLoadingBox(false);
    }, [selTree, retData]);
    function onClickDoUpdateCompany(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            setRecoilIsLoadingBox(true);
            data = yield HTTPUTIL.PromiseHttp({
                "httpMethod": "PUT",
                "appPath": `/api/v2/product/company/${companyInfo.companyId}`,
                appQuery: {
                    "companyName": companyInfo.companyName,
                    "url": companyInfo.url,
                    "businessNo": companyInfo.businessNo,
                    "administrator": companyInfo.administrator,
                    //"classification":companyInfo.classification,
                    "accountManager": companyInfo.accountManager,
                    "accMngrTelephone": companyInfo.accMngrTelephone,
                    "interfaceInfo": companyInfo.interfaceInfo,
                    "memo": companyInfo.memo
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                //const ERR_URL = HTTPUTIL.resultCheck(false, data);
                //if (ERR_URL.length > 0) navigate(ERR_URL);
                if (data.codeNum == CONST.API_200) {
                    clog("IN COMPANY UPDATE : onClickDoUpdateCompany : " + JSON.stringify(data.body));
                    setParentSelTree("COMPANY", Object.assign(Object.assign({}, selTree), { company: { "companyId": data.body.companyId, "companyName": data.body.companyName }, reload: true }));
                    setParentWorkMode("READ");
                }
                else { // api if
                    // need error handle
                    setErrorList(data.body.errorList);
                }
            }
            setRecoilIsLoadingBox(false);
        });
    }
    function onClickCancelUpdateCompany(e, company) {
        setParentSelTree("COMPANY", Object.assign(Object.assign({}, selTree), { company: { "companyId": company.companyId, "companyName": company.companyName }, reload: true }));
        setParentWorkMode("READ");
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "area__right_content workplace__info workplace__main info__input newtype", ref: mobileRef },
            React.createElement("div", { className: "page-top" },
                React.createElement("h2", null, "\uD68C\uC0AC \uC218\uC815")),
            React.createElement("div", { className: "content__info h-auto" },
                React.createElement("h3", { className: "hide" }, "\uD68C\uC0AC \uCD94\uAC00 \uC815\uBCF4 \uC785\uB825"),
                React.createElement("ul", { className: "form__input" },
                    React.createElement("li", null,
                        React.createElement("p", { className: "tit star" }, "\uD68C\uC0AC \uBA85"),
                        React.createElement("div", { className: "input__area" },
                            React.createElement("input", { type: "text", id: "inp4", placeholder: "\uD14D\uC2A4\uD2B8\uB97C \uC785\uB825\uD558\uC138\uC694", value: companyInfo.companyName, className: (errorList.filter(err => (err.field === "companyName")).length > 0) ? "input-error" : "", onChange: (e) => setCompanyInfo(Object.assign(Object.assign({}, companyInfo), { companyName: e.target.value })) }),
                            React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "companyName")).map((err) => err.msg)))),
                    React.createElement("li", null,
                        React.createElement("p", { className: "tit" }, "\uD68C\uC0AC URL"),
                        React.createElement("div", { className: "input__area" },
                            React.createElement("input", { type: "text", id: "inp5", placeholder: "URL\uC744 \uC785\uB825\uD558\uC138\uC694", value: companyInfo.url, className: (errorList.filter(err => (err.field === "url")).length > 0) ? "input-error" : "", onChange: (e) => setCompanyInfo(Object.assign(Object.assign({}, companyInfo), { url: e.target.value })) }),
                            React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "url")).map((err) => err.msg)))),
                    React.createElement("li", null,
                        React.createElement("p", { className: "tit star" }, "\uC0AC\uC5C5\uC790\uB4F1\uB85D\uBC88\uD638"),
                        React.createElement("div", { className: "input__area" },
                            React.createElement("input", { type: "text", id: "inp6", placeholder: "\uD14D\uC2A4\uD2B8\uB97C \uC785\uB825\uD558\uC138\uC694", value: companyInfo.businessNo, className: (errorList.filter(err => (err.field === "businessNo")).length > 0) ? "input-error" : "", onChange: (e) => setCompanyInfo(Object.assign(Object.assign({}, companyInfo), { businessNo: e.target.value })) }),
                            React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "businessNo")).map((err) => err.msg)))),
                    React.createElement("li", null,
                        React.createElement("p", { className: "tit" }, "\uB300\uD45C \uAD00\uB9AC\uC790"),
                        React.createElement("div", { className: "input__area" },
                            React.createElement("input", { type: "text", placeholder: "\uC9C1\uC811\uC785\uB825", value: companyInfo.administrator, className: (errorList.filter(err => (err.field === "administrator")).length > 0) ? "input-error" : "", onChange: (e) => setCompanyInfo(Object.assign(Object.assign({}, companyInfo), { administrator: e.target.value })) }),
                            React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "administrator")).map((err) => err.msg)))),
                    React.createElement("li", null,
                        React.createElement("p", { className: "tit" }, "\uCCAD\uAD6C/\uC815\uC0B0 \uB2F4\uB2F9"),
                        React.createElement("div", { className: "input__area" },
                            React.createElement("input", { type: "text", placeholder: "\uC9C1\uC811\uC785\uB825", value: companyInfo.accountManager, className: (errorList.filter(err => (err.field === "accountManager")).length > 0) ? "input-error" : "", onChange: (e) => setCompanyInfo(Object.assign(Object.assign({}, companyInfo), { accountManager: e.target.value })) }),
                            React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "accountManager")).map((err) => err.msg)))),
                    React.createElement("li", null,
                        React.createElement("p", { className: "tit" }, "\uCCAD\uAD6C/\uC815\uC0B0 \uB2F4\uB2F9 Tel"),
                        React.createElement("div", { className: "input__area" },
                            React.createElement("input", { type: "text", id: "inp10", placeholder: "\uD14D\uC2A4\uD2B8\uB97C \uC785\uB825\uD558\uC138\uC694", value: companyInfo.accMngrTelephone, className: (errorList.filter(err => (err.field === "accMngrTelephone")).length > 0) ? "input-error" : "", onChange: (e) => setCompanyInfo(Object.assign(Object.assign({}, companyInfo), { accMngrTelephone: e.target.value })) }),
                            React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "accMngrTelephone")).map((err) => err.msg)))),
                    React.createElement("li", null,
                        React.createElement("p", { className: "tit" }, "I/F Info"),
                        React.createElement("div", { className: "input__area" },
                            React.createElement("input", { type: "text", id: "inp11", placeholder: "\uD14D\uC2A4\uD2B8\uB97C \uC785\uB825\uD558\uC138\uC694", value: companyInfo.interfaceInfo, className: (errorList.filter(err => (err.field === "interfaceInfo")).length > 0) ? "input-error" : "", onChange: (e) => setCompanyInfo(Object.assign(Object.assign({}, companyInfo), { interfaceInfo: e.target.value })) }),
                            React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "interfaceInfo")).map((err) => err.msg)))),
                    React.createElement("li", null,
                        React.createElement("p", { className: "tit" }, "\uBA54\uBAA8"),
                        React.createElement("div", { className: "input__area" },
                            React.createElement("textarea", { placeholder: "\uBA54\uBAA8\uB97C \uC785\uB825\uD558\uC138\uC694.", className: (errorList.filter(err => (err.field === "memo")).length > 0) ? "input-error" : "", value: companyInfo.memo, onKeyPress: (e) => CUTIL.beforeHandleComment(e, 120), onKeyUp: (e) => CUTIL.afterHandleComment(e, 120, callbackSetCompanyInfoMemo), onChange: (e) => setCompanyInfo(Object.assign(Object.assign({}, companyInfo), { memo: e.target.value })) }),
                            React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "memo")).map((err) => err.msg)))),
                    React.createElement("li", null,
                        React.createElement("div", { className: "btn__wrap right w100p" },
                            React.createElement("button", { type: "button", className: "bg-gray", onClick: (e) => onClickCancelUpdateCompany(e, companyInfo) },
                                React.createElement("span", null, "\uCDE8\uC18C")),
                            React.createElement("button", { type: "button", onClick: (e) => onClickDoUpdateCompany(e) },
                                React.createElement("span", null, "\uC800\uC7A5")))))))));
}
;
export default CompanyUpdate;
